/** The app's AI-token mark — gold coins, same asset the profile drawer uses. */
export const TOKENS_ICON =
  "/icons/interface-icons/shared/icon-3d-gold-coins.png";
